module.exports = __webpack_public_path__ + "img/img-cartilha-ciclista.b3851f60.svg";